var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ruleSetting" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "setting-container mt14" },
          [
            _c(
              "el-row",
              [
                _c("el-col", _vm._b({}, "el-col", _vm.grid1, false), [
                  _vm._v(" "),
                ]),
                _vm._v(" "),
                _c(
                  "el-col",
                  _vm._b({}, "el-col", _vm.grid2, false),
                  [
                    _c(
                      "el-form",
                      {
                        ref: "elForm",
                        attrs: {
                          model: _vm.examineFrom,
                          rules: _vm.rules,
                          size: "medium",
                          "label-width": "150px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("business.handle") } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.examineFrom.abnormal,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.examineFrom, "abnormal", $$v)
                                  },
                                  expression: "examineFrom.abnormal",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v(_vm._s(_vm.$t("business.handle1"))),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v(_vm._s(_vm.$t("business.handle2"))),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.examineFrom.abnormal === 1
                              ? _c("select-member", {
                                  staticStyle: { width: "250px" },
                                  attrs: {
                                    "only-one": true,
                                    value: _vm.dataList || [],
                                  },
                                  on: { getSelectList: _vm.getSelectList },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("business.automatic") } },
                          [
                            _c("div", [
                              _vm._v(_vm._s(_vm.$t("business.automatic1"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-radio-group",
                              {
                                staticClass: "shu",
                                model: {
                                  value: _vm.examineFrom.auto,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.examineFrom, "auto", $$v)
                                  },
                                  expression: "examineFrom.auto",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v(_vm._s(_vm.$t("business.automatic2"))),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v(_vm._s(_vm.$t("business.automatic3"))),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v(_vm._s(_vm.$t("business.automatic4"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "shu",
                            attrs: { label: _vm.$t("business.editAuthority") },
                          },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.examineFrom.edit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.examineFrom, "edit", $$v)
                                  },
                                  expression: "examineFrom.edit",
                                },
                              },
                              [
                                _c("el-checkbox", { attrs: { label: 1 } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("business.editAuthority1"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: 2 } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("business.editAuthority2"))
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("business.revokeAuthority"),
                            },
                          },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.examineFrom.recall,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.examineFrom, "recall", $$v)
                                  },
                                  expression: "examineFrom.recall",
                                },
                              },
                              [
                                _c("el-checkbox", { attrs: { label: 1 } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("business.revokeAuthority1"))
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "explain" }, [
                              _vm._v(
                                _vm._s(_vm.$t("business.revokeAuthority2"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-col", _vm._b({}, "el-col", _vm.grid1, false), [
                  _vm._v(" "),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }